import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import AdjustmentDeliveryNoteStatusBar, { AdjustmentDeliveryNoteStatusBarNew, DeliveryNoteCreateStatusBarProps } from '../../../AdjustmentDNStatusBar'
import AdjustmentDeliveryNoteCreateNoPermissionButtons, { AdjustmentDeliveryNoteCreateNoPermissionButtonsNew } from '../AdjustmentDNCreateNoPermissionButtons'

type AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderProps = & DeliveryNoteCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderDecider: React.FC<AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderDefault} NewComponent={AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderNew} {...rest} />
    )
}

const AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderDefault: React.FC<AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <AdjustmentDeliveryNoteStatusBar {...rest} />
            <AdjustmentDeliveryNoteCreateNoPermissionButtons {...rest} />
        </div>
    )
}

const AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderNew: React.FC<AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <AdjustmentDeliveryNoteStatusBarNew {...rest} />
            <AdjustmentDeliveryNoteCreateNoPermissionButtonsNew {...rest} />
        </Fragment>
    )
}

export default AdjustmentDeliveryNoteCreateNoPermissionsStepHeaderDecider